import React, {useState} from "react";
import PredefinedKeyValueSetProperty, {KeyValuePropery} from "../properties/basic/PredefinedKeyValueSetProperty";
import toolService, {CncTool, CncToolType, formatToolName} from "../../service/ToolService";
import {fileEditorStore} from "../../stores/FileEditorStore";
import {EditorModeType} from "../../service/Editor";
import PredefinedNumberSetProperty from "../properties/basic/PredefinedNumberSetProperty";
import {observer} from "mobx-react-lite";

class ModeTrack {
    private modesShown: Array<EditorModeType> = []

    setShownMode(mode: EditorModeType) {
        if (this.modesShown[this.modesShown.length - 1] !== mode) {
            if (this.modesShown.length >= 2) {
                this.modesShown = this.modesShown.slice(1)
            }
            this.modesShown.push(mode)
        }
    }

    current(): EditorModeType {
        return this.modesShown[this.modesShown.length - 1]
    }

    previous(): EditorModeType {
        return this.modesShown[this.modesShown.length - 2]
    }
}

let modeTrack: ModeTrack = new ModeTrack()

type Properties = {
    onChangeTool: (cncTool: CncTool) => void
    onChangeHoleDiameter: (diameter: number) => void
}

function ToolSelector(props: Properties) {
    let cncTools = toolService.availableTools();
    const keyIndex: any = {}

    cncTools.forEach((value: CncTool, index: number) =>
        keyIndex[value.code] = index
    )
    const options: Array<KeyValuePropery> = cncTools
        .filter((cncTool: CncTool) => {
            if (fileEditorStore.currentMode == EditorModeType.ROUTES) {
                return cncTool.type == CncToolType.ENGRAVING || cncTool.type == CncToolType.MILLING
            }
        })
        .map((cncTool: CncTool) => {
            return {
                key: cncTool.code,
                value: formatToolName(cncTool)
            } as KeyValuePropery
        });

    const [selectedTool, setSelectedTool] = useState(options[0])
    const [selectedHoleDiameter, setSelectedHoleDiameter] = useState(
        0.5
    )

    function setTool(value: KeyValuePropery) {
        setSelectedTool(value)
        if (props.onChangeTool != null) {
            props.onChangeTool(cncTools[keyIndex[value.key]])
        }
    }

    function setHoleDiameter(diameter: number) {
        setSelectedHoleDiameter(diameter)
        if (props.onChangeHoleDiameter != null) {
            props.onChangeHoleDiameter(diameter)
        }
    }

    modeTrack.setShownMode(fileEditorStore.currentMode)

    const currentMode = modeTrack.current()
    const previousMode = modeTrack.previous()

    const holeDiameterSelectorElement = <>
        <PredefinedNumberSetProperty
            label={"Hole diameter"}
            val={selectedHoleDiameter}
            onChange={value => setHoleDiameter(value)}
            options={[0.3, 0.5, 0.7, 0.9, 1.0, 1.2, 1.3, 1.5, 2.0, 2.5, 3.0]}
            disable={currentMode == EditorModeType.G_CODE_ZERO}
        />
    </>

    const toolSelectorElement = <>
        <PredefinedKeyValueSetProperty
            label={"Tool"}
            val={selectedTool}
            onChange={value => setTool(value)}
            options={options}
            disable={currentMode == EditorModeType.G_CODE_ZERO}
        />
    </>

    let showHoleDiameterSelectorElement: boolean =
        currentMode == EditorModeType.DRILL ||
        (currentMode == EditorModeType.G_CODE_ZERO && previousMode == EditorModeType.DRILL)
    let showToolSelectorElement: boolean =
        (currentMode == EditorModeType.ROUTES || currentMode == EditorModeType.CUT) ||
        (currentMode == EditorModeType.G_CODE_ZERO && (previousMode == EditorModeType.ROUTES || previousMode == EditorModeType.CUT))

    return (<>
        {showHoleDiameterSelectorElement ? holeDiameterSelectorElement : <></>}
        {showToolSelectorElement ? toolSelectorElement : <></>}
    </>)
}

export default observer(ToolSelector)